<div class="modal_dialog assign-brand-modal">
  <div class="modal_header">
    <h2>{{ "AssignBrand" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="form-container">
      <div class="form_group">
        <megastore-admin-multi-column-select
          [isLoading]="isLoadingBrands"
          [options]="brands"
          [selectionConfig]="{ value: '_id', label: 'name' }"
          [selectionMode]="'multiple'"
          [columns]="3"
          [maxHeight]="'400px'"
          [placeholder]="'SelectBrands' | translate"
          [label]="'SelectBrands' | translate"
          [ngModel]="selectedBrands"
          [selectedValues]="selectedBrands"
          [defaultOpenState]="true"
          (ngModelChange)="onBrandSelectionChange($event)"
        ></megastore-admin-multi-column-select>
      </div>

      <div class="action-buttons">
        <button type="button" class="btnn btn_secondary" (click)="close()">
          {{ "Cancel" | translate }}
        </button>
        <button type="button" class="btnn btn_primary" (click)="save()">
          {{ "Save" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

